// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-failed {
  color: var(--color-error);
  font-size: var(--font-size-large);
}

.login-wrapper {
  display: flex;
  vertical-align: middle;
  height: 100vh;
  justify-content: center;
  align-items: center;
  position: relative;
}
.login-wrapper .login-form,
.login-wrapper .new-password-form {
  max-width: 50ch;
}
.login-wrapper .full-width,
.login-wrapper .btn-block {
  width: 100%;
}
.login-wrapper mat-card-header {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  text-align: center;
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-thin);
}
.login-wrapper mat-card-header mat-card-title {
  font-size: var(--font-size-x-large);
  margin: 0;
}
.login-wrapper .mat-card {
  padding: 2.5rem 4.4rem 3.1rem;
}
.login-wrapper .mat-card {
  opacity: 0;
  transform: translateY(60px);
  animation: fadeInUp 0.9s ease-out forwards;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.login-wrapper .mat-stroked-button {
  line-height: 3.4rem;
  background-color: rgb(243, 242, 241);
}
.login-wrapper .mat-form-field-appearance-legacy .mat-form-field-infix {
  padding: 0.8375em 0;
}
.login-wrapper .language-selector,
.login-wrapper .logo {
  position: absolute;
  top: 1rem;
}
.login-wrapper .language-selector {
  right: 1rem;
}
.login-wrapper .logo {
  left: 1rem;
}
.login-wrapper .forgot-password {
  display: flex;
  justify-content: flex-end;
}
.login-wrapper .new-password {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 1rem;
}

.background-image {
  position: absolute;
  inset: 0 0 0 0;
  opacity: 0.2;
  height: 100%;
  width: 100%;
  background-image: url(/images/map.png);
  background-color: var(--background-color-dark);
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
  filter: sepia(1) saturate(250%) hue-rotate(120deg) brightness(90%);
  transition: background-image var(--delay-short) fadeInUp, background-color var(--delay-long) var(--timing-function-default);
}

.app-header {
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}

.errors {
  color: var(--color-error);
  font-size: var(--font-size-large);
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;;EAGE,eAAA;AAAJ;AAGE;;EAEE,WAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;AAFJ;AAII;EACE,mCAAA;EACA,SAAA;AAFN;AAME;EACE,6BAAA;AAJJ;AAOE;EACE,UAAA;EACA,2BAAA;EACA,0CAAA;AALJ;AAQE;EACE;IACE,UAAA;IACA,2BAAA;EANJ;EASE;IACE,UAAA;IACA,wBAAA;EAPJ;AACF;AAUE;EACE,mBAAA;EACA,oCAAA;AARJ;AAWE;EACE,mBAAA;AATJ;AAYE;;EAEE,kBAAA;EACA,SAAA;AAVJ;AAaE;EACE,WAAA;AAXJ;AAcE;EACE,UAAA;AAZJ;AAeE;EACE,aAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,+BAAA;EACA,SAAA;AAdJ;;AAqBA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EAEA,kEAAA;EAEA,2HAAA;AApBF;;AAwBA;EACE,8BAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,iHAAA;AArBF;;AAwBA;EACE,yBAAA;EACA,iCAAA;AArBF","sourcesContent":[".login-failed {\n  color: var(--color-error);\n  font-size: var(--font-size-large);\n}\n\n.login-wrapper {\n  display: flex;\n  vertical-align: middle;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  .login-form,\n  .new-password-form {\n\n    max-width: 50ch;\n  }\n\n  .full-width,\n  .btn-block {\n    width: 100%;\n  }\n\n  mat-card-header {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr auto;\n    text-align: center;\n    font-weight: var(--font-weight-bold);\n    margin-bottom: var(--spacing-thin);\n\n    mat-card-title {\n      font-size: var(--font-size-x-large);\n      margin: 0;\n    }\n  }\n\n  .mat-card {\n    padding: 2.5rem 4.4rem 3.1rem\n  }\n\n  .mat-card {\n    opacity: 0;\n    transform: translateY(60px);\n    animation: fadeInUp 0.9s ease-out forwards;\n  }\n\n  @keyframes fadeInUp {\n    from {\n      opacity: 0;\n      transform: translateY(60px);\n    }\n\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .mat-stroked-button {\n    line-height: 3.4rem;\n    background-color: rgb(243, 242, 241);\n  }\n\n  .mat-form-field-appearance-legacy .mat-form-field-infix {\n    padding: 0.8375em 0;\n  }\n\n  .language-selector,\n  .logo {\n    position: absolute;\n    top: 1rem;\n  }\n\n  .language-selector {\n    right: 1rem;\n  }\n\n  .logo {\n    left: 1rem;\n  }\n\n  .forgot-password {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .new-password {\n    display: grid;\n    grid-template-columns: 1fr auto;\n    gap: 1rem;\n  }\n\n}\n\n\n\n.background-image {\n  position: absolute;\n  inset: 0 0 0 0;\n  opacity: 0.2;\n  height: 100%;\n  width: 100%;\n  background-image: url(/images/map.png);\n  background-color: var(--background-color-dark);\n  background-repeat: no-repeat;\n  background-size: cover;\n  user-select: none;\n  cursor: default;\n\n  filter: sepia(1) saturate(250%) hue-rotate(120deg) brightness(90%);\n\n  transition: background-image var(--delay-short) fadeInUp, background-color var(--delay-long) var(--timing-function-default);\n}\n\n\n.app-header {\n  justify-content: space-between;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\n}\n\n.errors {\n  color: var(--color-error);\n  font-size: var(--font-size-large);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
